import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';
import FundingRequestService from '@/services/FundingRequestService';
import PreferenceService from '@/services/PreferenceService';

/**
 * Funding service configurations
 * These services are used by the funding module
 */
export const fundingServices: ServiceConfig[] = [
  {
    name: 'fundingService',
    factory: () => new BaseService('/api/funding-service'),
  },
  {
    name: 'fundingDealService',
    factory: () => new BaseService('/api/funding-service/deals'),
  },
  {
    name: 'fundingReportService',
    factory: () => new BaseService('/api/funding-service/reports'),
  },
  {
    name: 'fundingAnalyticsService',
    factory: () => new BaseService('/api/funding-service/analytics'),
  },
  {
    name: 'fundingRequestService',
    factory: () => new FundingRequestService(),
  },
  {
    name: 'preferenceService',
    factory: () => new PreferenceService(),
  },
];

/**
 * Funding-specific service factory
 * Creates a custom service with funding-specific configuration
 */
export const createFundingCustomService = (
  serviceName: string,
  baseUrl: string = '/api/funding-service',
): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});

/**
 * Funding service utilities
 */
export const fundingServiceUtils = {
  /**
   * Get all funding service names
   */
  getServiceNames: () => fundingServices.map(s => s.name),

  /**
   * Check if a service name is a funding service
   */
  isFundingService: (name: string) => fundingServices.some(s => s.name === name),

  /**
   * Get funding base path
   */
  getBasePath: () => '/securitization/funding',
};
